import Button from './Button.js';

export default Button;
